import { Dispatch } from "redux";
import { setAttributeLabelDetails, setAttributeLabelDetailsLoading } from "@redux/actions/attribute-label-details-actions";
import { getAxnAttributeLabelRequest } from "@requests/management-console/get-axn-attribute-label";
import { FormattedAxnAttributeLabel, AxnAttributeType } from "@idw-types/data/reference-data/axn";
import { formatAxnAttributeLabel } from "@formatters/axn-attribute-labels/axn-attribute-label-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getAttributeLabelDetailsReduxRequest = (dispatch: Dispatch) => async (
    axnAttributeLabelId: string,
    axnAttributeTypes: Array<AxnAttributeType>
): Promise<FormattedAxnAttributeLabel> => {
    dispatch(setAttributeLabelDetailsLoading(true));
    const { data, error } = await getAxnAttributeLabelRequest(axnAttributeLabelId);

    if (data) {
        const formattedAttributeLabel = formatAxnAttributeLabel(data, axnAttributeTypes);
        dispatch(setAttributeLabelDetails(formattedAttributeLabel));
        return formattedAttributeLabel;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAttributeLabelDetails.error.title,
                resources.requests.getAttributeLabelDetails.error.message
            );
        }
        dispatch(setAttributeLabelDetailsLoading(false));
        return null;
    }
};